import { THIEN_CAN_ORDER, DIA_CHI_ORDER } from './canchi_year.js';
import {
  DEFAULT_TZ_OFFSET_MINUTES,
  addDaysToDateParts,
  getDateParts,
  normalizeTimezoneOffset,
  toUtcDateFromLocal
} from './time.js';

const JDN_CONVENTION = 'local_civil_date';

const toJulianDayNumber = (year, month, day) => {
  const a = Math.floor((14 - month) / 12);
  const y = year + 4800 - a;
  const m = month + 12 * a - 3;
  return day
    + Math.floor((153 * m + 2) / 5)
    + 365 * y
    + Math.floor(y / 4)
    - Math.floor(y / 100)
    + Math.floor(y / 400)
    - 32045;
};

const formatDateParts = ({ year, month, day }) => {
  const pad = (value) => `${value}`.padStart(2, '0');
  return `${year}-${pad(month + 1)}-${pad(day)}`;
};

const normalizeHour = (hourValue = 0) => {
  const safeHour = Number.isFinite(hourValue) ? hourValue : 0;
  const extraDays = Math.floor(safeHour / 24);
  const normalized = ((safeHour % 24) + 24) % 24;
  return { normalized, extraDays };
};

export function getCanChiDay(
  date,
  {
    hour = 0,
    timezoneOffsetMinutes = DEFAULT_TZ_OFFSET_MINUTES,
    rolloverAt23 = false
  } = {}
) {
  const normalizedOffset = normalizeTimezoneOffset(timezoneOffsetMinutes);
  const { normalized: hourLocal, extraDays } = normalizeHour(hour);
  const baseDateParts = getDateParts(date);
  const civilDateParts = addDaysToDateParts(baseDateParts, extraDays);
  const rolloverApplied = rolloverAt23 && hourLocal >= 23;
  const effectiveDateParts = addDaysToDateParts(
    civilDateParts,
    rolloverApplied ? 1 : 0
  );

  // Keep the physical UTC date only as provenance. The sexagenary day itself is
  // anchored to the normalized local civil date (plus the explicit 23:00 rule,
  // when enabled), not to the UTC calendar date.
  const utcDate = toUtcDateFromLocal(civilDateParts, hourLocal, normalizedOffset);
  const year = effectiveDateParts.year;
  const month = effectiveDateParts.month + 1;
  const day = effectiveDateParts.day;
  const julianDay = toJulianDayNumber(year, month, day);
  const canIndex = ((julianDay + 9) % 10 + 10) % 10;
  const chiIndex = ((julianDay + 1) % 12 + 12) % 12;

  return {
    date: formatDateParts(effectiveDateParts),
    civilDate: formatDateParts(civilDateParts),
    utcDate: formatDateParts(getDateParts(utcDate)),
    hourLocal,
    timezoneOffsetMinutes: normalizedOffset,
    rolloverApplied,
    rolloverAt23: Boolean(rolloverAt23),
    jdn: julianDay,
    jdnConvention: JDN_CONVENTION,
    reference: {
      formula: 'stemIndex = (JDN + 9) % 10; branchIndex = (JDN + 1) % 12',
      verified_by: 'independent-local-date-golden-fixtures',
      day_boundary: rolloverAt23 ? '23:00 local normalized time' : '00:00 local civil time',
      anchor: {
        date: '2019-01-27',
        jdn: 2458511,
        can: 'Giap',
        chi: 'Ty',
        note: 'Jia-Zi day anchor; JDN and sexagenary offsets independently cross-checked.'
      }
    },
    canIndex,
    chiIndex,
    can: THIEN_CAN_ORDER[canIndex],
    chi: DIA_CHI_ORDER[chiIndex],
    label: `${THIEN_CAN_ORDER[canIndex]} ${DIA_CHI_ORDER[chiIndex]}`
  };
}
